import { useSelector } from "react-redux";
import HeroSection from "./smartbuilding/sections/1-sb-HeroSection";
import IntroSection from "./smartbuilding/sections/2-sb-IntroSection";
import FeaturesSection from "./smartbuilding/sections/3-sb-FeaturesSection";
import ScreenSection from "./smartbuilding/sections/4-sb-ScreenSection";
import UsersRolesSection from "./smartbuilding/sections/5-sb-UsersRolesSection";
import ControlEquipementSection from "./smartbuilding/sections/6-sb-ControlEquipementSection";
import InstallationSection from "./smartbuilding/sections/6-sb-InstallationSection";
import EdgeComputingSection from "./smartbuilding/sections/7-sb-EdgeComputing";
import DataSecurity from "./smartbuilding/sections/8-sb-DataSecurity";
import MadeInFranceSection from "./smartbuilding/sections/9-sb-MadeInFranceSection";
import KeepControl from "./smartbuilding/sections/10-sb-KeepControl";
import BusinessModel from "./smartbuilding/sections/11-sb-BusinessModel";
import textContentSmartBuildingHeroSection from "./smartbuilding/ui/textContent-smartbuilding-heroSection";
import textContentSmartbuildingIntro from "./smartbuilding/ui/textContent-smartbuilding-intro";
import textContentSmartbuildingFeatures from "./smartbuilding/ui/textContent-smartbuilding-features";
import textContentSmartbuildingScreens from "./smartbuilding/ui/textContent-smartbuilding-screens";
import textContentSmartbuildingUsersAndRoles from "./smartbuilding/ui/textContent-smartbuilding-usersAndRoles";
import textContentSmartbuildingInstallation from "./smartbuilding/ui/textContent-smartbuilding-installation";
import textContentSmartbuildingControlEquipement from "./smartbuilding/ui/textContent-smartbuilding-controlEquipement";
import textContentSmartbuildingEdgeComputing from "./smartbuilding/ui/textContent-smartbuilding-edgeComputing";
import textContentSmarthomeContactUsSection from "./smarthome/ui/textContent-smarthome-contactUsSection";
import textContentSmartbuildingData from "./smartbuilding/ui/textContent-smartbuilding-data";
import textContentSmartbuildingMadeInFrance from "./smartbuilding/ui/textContent-smartbuilding-madeInFrance";
import textContentSmartbuildingKeepControl from "./smartbuilding/ui/textContent-smartbuilding-keepControl";
import textContentSmartbuildingBusinessModel from "./smartbuilding/ui/textContent-smartbuilding-businessModel";
import ContactUs from "./smarthome/sections/3-ContactUs";

function SmartbuildingPage() {
  const language = useSelector((state) => state.dictionary.language);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <>
      <HeroSection
        textContent={textContentSmartBuildingHeroSection}
        language={language}
      />

      <div
        className={
          isMobile ? "container-empty-small" : "container-empty-medium"
        }
      />
      <div className="container-empty-extra-small" />
      <IntroSection
        language={language}
        textContent={textContentSmartbuildingIntro}
      />
      <div className="container-empty-medium" />
      <FeaturesSection
        language={language}
        textContent={textContentSmartbuildingFeatures}
      />
      <ScreenSection
        language={language}
        textContent={textContentSmartbuildingScreens}
      />
      <div
        className={
          isMobile ? "container-empty-small" : "container-empty-extra-small"
        }
      />
      <ControlEquipementSection
        language={language}
        textContent={textContentSmartbuildingControlEquipement}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />

      <UsersRolesSection
        language={language}
        textContent={textContentSmartbuildingUsersAndRoles}
      />
      <div className={isMobile ? "container-empty-medium" : ""} />
      {isMobile ? (
        <ContactUs
          textContent={textContentSmarthomeContactUsSection}
          language={language}
        />
      ) : null}
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
      <InstallationSection
        language={language}
        textContent={textContentSmartbuildingInstallation}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
      <EdgeComputingSection
        language={language}
        textContent={textContentSmartbuildingEdgeComputing}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
      <DataSecurity
        language={language}
        textContent={textContentSmartbuildingData}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
      <div className={isMobile ? "" : "container-empty-extra-small"} />
      <MadeInFranceSection
        language={language}
        textContent={textContentSmartbuildingMadeInFrance}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-large"
        }
      />
      <KeepControl
        language={language}
        textContent={textContentSmartbuildingKeepControl}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-small"
        }
      />
      <BusinessModel
        language={language}
        textContent={textContentSmartbuildingBusinessModel}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
      <ContactUs
        textContent={textContentSmarthomeContactUsSection}
        language={language}
      />
      <div
        className={
          isMobile ? "container-empty-medium" : "container-empty-medium"
        }
      />
    </>
  );
}

export default SmartbuildingPage;
